import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const tyaRoutes: Routes = [
  {
    path: "tya_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioTYAComponent
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_calendario",
    loadComponent: () =>
      import("./components/calendario/calendario.component").then(
        (m) => m.CalendarioTYAComponent
      ),
    data: {
      label: "Calendario",
      icon: "calendar_month",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_gestion-fichadas",
    loadComponent: () =>
      import("./components/gestion-fichadas/gestion-fichadas.component").then(
        (m) => m.GestionFichadasComponent
      ),
    data: {
      label: "Gestion_Fichadas",
      icon: "manage_accounts",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_modificacion-jornada",
    loadComponent: () =>
      import(
        "./components/modificacion-jornada/modificacion-jornada.component"
      ).then((m) => m.ModificacionJornadaComponent),
    data: {
      label: "Modificacion_Jornada",
      icon: "drive_file_rename_outline",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_consultas",
    loadComponent: () =>
      import("./components/consultas/consultas.component").then(
        (m) => m.ConsultasComponent
      ),
    data: {
      label: "Consultas",
      icon: "list_alt",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_consultas-inconsistencias",
    loadComponent: () =>
      import("./components/inconsistencias/inconsistencias.component").then(
        (m) => m.InconsistenciasComponent
      ),
    data: {
      label: "Inconsistencias",
      icon: "assignment",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_importacion",
    loadComponent: () =>
      import(
        "./components/importacion-fichadas/importacion-fichadas.component"
      ).then((m) => m.ImportacionFichadasComponent),
    data: {
      label: "Importacion_Fichadas",
      icon: "upload_file",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_envio-liq",
    loadComponent: () =>
      import("./components/envio-liquidacion/envio-liquidacion.component").then(
        (m) => m.EnvioLiquidacionTYAComponent
      ),
    data: {
      label: "Envio-Liquidacion",
      icon: "send",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_jornadas",
    loadChildren: () =>
      import("./components/jornadas/jornadas.routes").then(
        (m) => m.jornadasRoutes
      ),
    data: {
      label: "Jornadas",
      icon: "date_range",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_modelos",
    loadChildren: () =>
      import("./components/modelos/modelos.routes").then(
        (m) => m.modelosRoutes
      ),
    data: {
      label: "Modelos",
      icon: "settings_applications",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_asignacion",
    loadComponent: () =>
      import(
        "./components/asignacion-modelos/asignacion-modelos.component"
      ).then((m) => m.AsignacionModelosComponent),
    data: {
      label: "Asignacion_Modelos",
      icon: "assignment_turned_in",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "tya_relojes",
    loadChildren: () =>
      import("./components/relojes/relojes.routes").then(
        (m) => m.relojesRoutes
      ),
    data: {
      label: "Relojes",
      icon: "timer",
      urlexterna: "TYA",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
